/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'fabric.linkPicker.button.cancel': 'Avbryt',
  'fabric.linkPicker.button.insert': 'Infoga',
  'fabric.linkPicker.button.save': 'Spara',
  'fabric.linkPicker.clearLink': 'Rensa',
  'fabric.linkPicker.clearLinkText': 'Rensa text',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {inga resultat hittades} one {{count,number} resultat hittades} other {{count,number} resultat hittades}}',
  'fabric.linkPicker.linkAriaLabel': 'Skriv eller klistra in en länk i fältet',
  'fabric.linkPicker.linkInvalid': 'Ange en giltig webbadress.',
  'fabric.linkPicker.linkLabel': 'Länk',
  'fabric.linkPicker.linkPlaceholder': 'Klistra in en länk',
  'fabric.linkPicker.linkTextAriaLabel': 'Visningstext för länk',
  'fabric.linkPicker.linkTextLabel': 'Visningstext (valfritt)',
  'fabric.linkPicker.linkTextPlaceholder': 'Text att visa',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Nyligen visade',
  'fabric.linkPicker.listTitle.results': 'Resultat',
  'fabric.linkPicker.search.error.description': 'Uppdatera sidan eller kontakta <a>Atlassians support</a> om problemet kvarstår.',
  'fabric.linkPicker.search.error.heading': 'Vi kan inte läsa in data.',
  'fabric.linkPicker.search.linkAriaLabel': 'Förslag visas nedan när du skriver i fältet',
  'fabric.linkPicker.search.linkLabel': 'Sök eller klistra in en länk',
  'fabric.linkPicker.search.linkPlaceholder': 'Hitta senaste länkar eller klistra in en ny länk',
  'fabric.linkPicker.search.noResults.description': 'Försök med ett annat sökord.',
  'fabric.linkPicker.search.noResults.heading': 'Vi kunde inte hitta några träffar för din sökning.',
  'fabric.linkPicker.status.submitting': 'Skickar in',
  'fabric.linkPicker.time.message.updated': 'Uppdaterades {time}',
  'fabric.linkPicker.time.message.viewed': 'Visades {time}',
  'fabric.linkPicker.unhandledError.description': 'Försök uppdatera sidan.',
  'fabric.linkPicker.unhandledError.heading': 'Något gick fel!'
};